import { UtensilsCrossed } from 'lucide-react';
import RecordManager from '../components/RecordManager';

export default function Recipes() {
  return (
    <RecordManager
      apiPath="recipes"
      testid="recipes"
      title="Family Recipes"
      subtitle="Pass down the flavors that made your family feel like home."
      icon={UtensilsCrossed}
      accent="gold"
      addLabel="Add Recipe"
      emptyText="No recipes yet. Preserve a cherished family recipe and the story behind it."
      titleField="title"
      subtitleFields={['category']}
      hasPhoto
      fields={[
        { name: 'title', label: 'Recipe name', placeholder: 'e.g., Grandma\'s Apple Pie' },
        { name: 'category', label: 'Category', placeholder: 'e.g., Dessert, Holiday, Main dish' },
        { name: 'ingredients', label: 'Ingredients', type: 'textarea', placeholder: 'List each ingredient on a new line.' },
        { name: 'instructions', label: 'Instructions', type: 'textarea', placeholder: 'Step-by-step directions.' },
        { name: 'story', label: 'The story behind it', type: 'textarea', placeholder: 'Where it came from, who made it, favorite memories…' },
      ]}
    />
  );
}
